import React from 'react'
import { FormattedNumber } from 'react-intl'

type FormattedCurrencyProps = {
  amount: number
  currencyCode: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  crypto?: boolean
}

const FormattedCurrency: React.FC<FormattedCurrencyProps> = ({
  amount,
  currencyCode,
  minimumFractionDigits = 0,
  maximumFractionDigits = 2,
  crypto = false,
}) => {
  if (crypto) maximumFractionDigits = 18
  // fallback for non-standard codes that don't conform to ISO 3-letter spec (e.g. USDT)
  if (crypto || currencyCode.length !== 3)
    return (
      <>
        <FormattedNumber
          value={amount}
          minimumFractionDigits={minimumFractionDigits}
          maximumFractionDigits={maximumFractionDigits}
        />{' '}
        {currencyCode}
      </>
    )
  // regular formatter
  return (
    <FormattedNumber
      style="currency"
      currency={currencyCode}
      value={amount}
      minimumFractionDigits={minimumFractionDigits}
      maximumFractionDigits={maximumFractionDigits}
    />
  )
}
export default FormattedCurrency
